import store from '@zapier/local-storage';
import z from 'app/common/z';

// a local storage adapter and related functions for interfacing with persistent local storage
z.store = store;